module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cc-chat-panel"
  }, [_c('div', {
    ref: "messagesContainer",
    staticClass: "cc-chat-panel-messages"
  }, [_vm._l((_vm.messages), function(message, index) {
    return [(message.role === 'system') ? _c('system-message', {
      key: 's-' + index,
      attrs: {
        "text": message.text,
        "content": message.content,
        "timestamp": message.timestamp,
        "is-last": index === _vm.messages.length - 1,
        "streaming": !!message.streaming
      },
      on: {
        "action": function($event) {
          return _vm.handleAction($event, index)
        }
      }
    }) : (message.role === 'user') ? _c('user-message', {
      key: 'u-' + index,
      attrs: {
        "text": message.text,
        "initials": _vm.userInitials,
        "timestamp": message.timestamp
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('chat-input-bar', {
    ref: "inputBar",
    attrs: {
      "loading": _vm.loading,
      "locked": _vm.context.step === 'done',
      "locked-text": "Chat closed. Start a new chat to make another template."
    },
    on: {
      "send": _vm.handleSend
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0d0fdd7c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/create-template/TemplateChatPanel.vue
// module id = G9JH
// module chunks = 1